import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { isWorkerRole } from '../utils/roles.js';
import { showJornadaGuiaTrial } from '../data/jornadaConversationScript.js';
import JornadaConversation from '../components/JornadaConversation.jsx';
import '../components/JornadaConversation.css';

export default function JornadaGuia() {
    const { user } = useAuth();

    if (!isWorkerRole(user?.rol ?? user?.role) || !showJornadaGuiaTrial(user)) {
        return (
            <div className="jguia-page-head">
                <p>Esta prueba no está activa en tu empresa.</p>
                <Link className="jguia-back" to="/">
                    Volver a la jornada de siempre
                </Link>
            </div>
        );
    }

    return (
        <div>
            <header className="jguia-page-head">
                <h1>Guía (prueba)</h1>
                <p>Misma jornada, en conversación. Si no te gusta, vuelve atrás: nada se desarmó.</p>
                <Link className="jguia-back" to="/">
                    ← Volver a la jornada de siempre
                </Link>
            </header>
            <JornadaConversation user={user} />
        </div>
    );
}
